/**
 * Configurable fields for Kanban cards and deal table columns
 */

export const KANBAN_FIELDS = [
    { key: 'accountName', label: 'Account', default: true },
    { key: 'dealOwner', label: 'Sales Rep', default: true },
    { key: 'dealAmount', label: 'Amount', default: true },
    { key: 'forecastAmount', label: 'Forecast', default: true },
    { key: 'expectedCloseDate', label: 'Expected close', default: true },
    { key: 'nextStep', label: 'Next step', default: true },
    { key: 'probability', label: 'Probability', default: false },
    { key: 'primaryContactName', label: 'Primary contact', default: false },
    { key: 'dealPipeline', label: 'Pipeline', default: false },
    { key: 'status', label: 'Status', default: false },
    { key: 'dealStage', label: 'Stage label', default: false }
];

export const TABLE_COLUMNS = [
    { key: 'dealName', label: 'Deal Name', sortable: true, default: true },
    { key: 'clientName', label: 'Account', sortable: true, default: true },
    { key: 'dealOwner', label: 'Sales Rep', sortable: true, default: true },
    { key: 'dealStage', label: 'Stage', sortable: true, default: true },
    { key: 'dealAmount', label: 'Amount', sortable: true, numeric: true, default: true },
    { key: 'forecastAmount', label: 'Forecast', sortable: true, numeric: true, default: true },
    { key: 'probability', label: 'Probability', sortable: true, numeric: true, default: false },
    { key: 'expectedCloseDate', label: 'Expected Close', sortable: true, default: true },
    { key: 'nextStep', label: 'Next Step', sortable: true, default: true },
    { key: 'status', label: 'Status', sortable: true, default: false },
    { key: 'dealPipeline', label: 'Pipeline', sortable: true, default: false },
    { key: 'createdAt', label: 'Created Date', sortable: true, default: false },
    { key: 'createdByName', label: 'Created By', sortable: true, default: false },
    { key: 'updatedAt', label: 'Last Modified Date', sortable: true, default: false },
    { key: 'updatedByName', label: 'Last Modified By', sortable: true, default: false }
];

const KANBAN_STORAGE = 'quickcrm_kanban_fields';
const TABLE_STORAGE = 'quickcrm_table_columns';

export function getKanbanFieldPrefs() {
    try {
        const raw = localStorage.getItem(KANBAN_STORAGE);
        if (raw) return JSON.parse(raw);
    } catch { /* ignore */ }
    return KANBAN_FIELDS.filter(f => f.default).map(f => f.key);
}

export function saveKanbanFieldPrefs(keys) {
    localStorage.setItem(KANBAN_STORAGE, JSON.stringify(keys));
}

export function getTableColumnPrefs() {
    try {
        const raw = localStorage.getItem(TABLE_STORAGE);
        if (raw) return JSON.parse(raw);
    } catch { /* ignore */ }
    return TABLE_COLUMNS.filter(c => c.default).map(c => c.key);
}

export function saveTableColumnPrefs(keys) {
    localStorage.setItem(TABLE_STORAGE, JSON.stringify(keys));
}
